


































































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import Validator from "../../../components/Validator/validator.vue";
import { isObject } from "@szgc/plt-core-v2";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "TextWidget",
  components: { Validator, MagicValidator }
})
export default class TextWidget extends EventWidgetComponent implements App.PuttedWidgetComponent {
  setValue(value: string) {
    this.value = value;
    this.operateHandler();
  }

  valueChange(value: string) {
    this.handleEvent(value);
    this.operateHandler();
  }

  mounted() {
    if (this.status === "mine") {
      this.value =
        this.widget.ext === null
          ? isObject(this.defaultValue)
            ? this.defaultValue.value
            : this.defaultValue
          : this.widget.value;
    }
  }
}
